import { connect } from "react-redux";
import { createPedido } from '../../../redux/actions/solicitud';
import { useNavigate } from 'react-router-dom';
import styles from './RequestConfirmation.module.css';
const RequestConfirmation = ({pedido, setShowConfirmar, createPedido}) =>{
    const navigate = useNavigate();

    const handleVolverClick = () => {
        setShowConfirmar(false);
    };

    const handleEnviarClick = () => {

        // Llamamos a createPedido con el pedido como argumento.
        // Se captura el error para evitar un "Uncaught (in promise)" si el backend falla.
        createPedido(pedido).catch((err) => {
            console.error('No se pudo crear la solicitud:', err?.response?.data || err?.message || err);
        });
        setShowConfirmar(false);
        navigate('/landing');
    };
    return(
        <div className={styles.backdrop}>
            <div className={styles.dialog}>
                <div className={styles.options}>
                    <h1>¿Estás seguro?</h1>
                    <div className={styles.buttons}>
                        <button onClick={handleVolverClick} >Volver</button>
                        <button onClick={handleEnviarClick}>Enviar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
const mapStateToProps = (state) => ({

  });
  
  export default connect(mapStateToProps, {
    createPedido
  })(RequestConfirmation);
  